import { render, staticRenderFns } from "./Singer.vue?vue&type=template&id=1ab952c6&scoped=true&"
import script from "./Singer.vue?vue&type=script&lang=js&"
export * from "./Singer.vue?vue&type=script&lang=js&"
import style0 from "./Singer.vue?vue&type=style&index=0&id=1ab952c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab952c6",
  null
  
)

export default component.exports